const defaultAccess = [
  'Chief',
  'Admin',
  'CompoundingAdmin',
  'CompoundingChief',
  'Viewer',
  'CompoundingViewer',
];
const qcAccess = ['CompoundingQC', 'QualityControl', 'QualityControlInspector'];
const schedulingAccess = [
  ...defaultAccess,
  'CompoundingSupervisorScheduling',
  'CompoundingOperator',
  'CompoundingLeader',
  'CompoundingChemist',
  'CompoundingEngineer',
];
const allAccess = [...schedulingAccess, ...qcAccess];

const defaultAccessING = [
  'Chief',
  'Admin',
  'CompoundingAdmin',
  'CompoundingChief',
];
const allAccessING = [
  ...defaultAccessING,
  'CompoundingOperator',
  'CompoundingLeader',
  'CompoundingEngineer',
  'CompoundingSupervisorScheduling',
  'CompoundingChemist',
  'CompoundingLabelOperator',
];
export const compoudingAccionesRoles = {
  sharedActions: {
    schedulingMixingMill: [...schedulingAccess],
    schedulingPreformas: [...schedulingAccess],
    schedulingExtruderTabs: [...allAccess],
    schedulingCalender: [...schedulingAccess],
    schedulingExtrusion: [...allAccess],
    validation: [
      ...defaultAccess,
      'CompoundingLeader',
      'CompoundingSupervisorScheduling',
    ],
    packingBox: ['Admin', 'Chief', 'LabelOperator', 'CompoundingLabelOperator'],
    workOrderInfo: [...allAccess],
    qcData: [...defaultAccess, ...qcAccess],
    efficiency: [
      'Chief',
      'Admin',
      'CompoundingAdmin',
      'CompoundingChief',
      'CompoundingSupervisor',
      'StandardsAdmin',
      'CompoundingStandardsAdmin',
      'CompoundingEngineer',
    ],
  },

  routerActions: {
    schedulingRoot: [...schedulingAccess],
    schedulingQualityControl: [...defaultAccess, ...qcAccess],
    laboratoryData: [...defaultAccess, 'CompoundingChemist'],
    laboratoryTest: [...defaultAccess, 'CompoundingChemist'],
  },

  sideNavActions: {
    main: [...allAccessING, ...qcAccess], // ← Añadido para CompoundingRoutes
    reportsPbiCompounding: [...allAccessING, ...qcAccess],
  },
};
